<template>
    <span>
        <b-card no-body>
            <b-card-header>
                <b-row>
                    <b-col sm="12">
                        <h3>Visualizar Tutorial</h3>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body>
                <b-form>
                    <b-row>
                        <b-col sm="12" md="8">
                            <b-form-group label="Título: *">
                                <b-input-group class="mb-3">
                                    <b-form-input type="text" placeholder="Título Tutorial" v-model="$v.form.titulo.$model"
                                        disabled class="form-control" />
                                    <b-form-invalid-feedback id="input1LiveFeedback1">Título é
                                        obrigatório.</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4">
                            <b-form-group label="Status:">
                                <b-form-radio-group disabled v-model="$v.form.status.$model" id="radio-slots"
                                    :options="options" name="radio-options-slots" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <hr>
                    <b-row>
                        <b-col sm="12" md="6">
                            <b-form-group tabindex="0" label="Item Tutorial: ">
                                <b-form-select v-model.trim="form.item" disabled placeholder="Item" class="mb-3">
                                    <option :value="null" selected> Selecione </option>
                                    <option v-for="item in option_itens" :key="item.tipo" :value="item.tipo">
                                        {{ item.nome }}</option>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <div class="adicionarItem">
                                <b-button variant="success" disabled @click="adicionarItem"><i class="fa fa-plus"></i>
                                    Adicionar</b-button>
                            </div>
                        </b-col>
                    </b-row>
                    <span v-for="(item, index) in itens" :key="index">
                        <b-row v-if="item.tipo == 'TE'">
                            <b-col sm="12" md="12">
                                <b-form-group tabindex="0" label="Texto">
                                   <span v-html="form.texto[index].texto" ></span>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="item.tipo == 'AR'">
                            <b-col sm="12">
                                <b-form-group tabindex="0" label="Documento:">
                                    <b-card>
                                        <table class="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th tabindex="0">#</th>
                                                    <th tabindex="0">Nome</th>
                                                    <th tabindex="0">Ação</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="!form.files[index].files.length">
                                                    <td tabindex="0" colspan="7">
                                                        <div class="text-center p-5">
                                                            <h4>Nenhum documento adicionado</h4>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr v-for="(file, i) in form.files[index].files" :key="file.id">
                                                    <td tabindex="0">{{ i + 1 }}</td>
                                                    <td tabindex="0">
                                                        <div class="filename">
                                                            {{ file.name }}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <span>
                                                            <b-button class="btn btn-sm btn-secondary action"
                                                                title="Visualizar" @click="abrirDocumento(file.caminho)">
                                                                <i class="fa fa-eye">&nbsp;</i>
                                                            </b-button>
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </b-card>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="item.tipo == 'SV'">
                            <b-col cols="12">
                                <b-form-group label="Url do Vídeo:">
                                    <b-form-input type="text" class="form-control" placeholder="Url do Vídeo"
                                        autocomplete="url" v-model="form.video_url[index].video_url" disabled autofocus />
                                    <b-form-invalid-feedback id="input1LiveFeedback9">Url do vídeo é
                                        obrigatória.</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="item.tipo == 'UV'">
                            <b-col sm="12" md="12">
                                <label tabindex="0"><strong>Upload Vídeo:</strong></label>
                                <b-form-group label-for="nome-input" invalid-feedback="Banner é obrigatório!">
                                    <b-form-file v-on:change="uploadArquivo(index, $event)"
                                        v-model="form.video_upload[index].video_upload" browse-text="Selecione" disabled
                                        :placeholder="form.video_upload[index].video_upload ? form.video_upload[index].video_upload : 'Selecione um arquivo de video'"
                                        tabindex="0">
                                    </b-form-file>
                                </b-form-group>
                                <p><a :href="form.video_upload[index].url_video" target="_blank">Ver Vídeo</a></p>
                            </b-col>
                        </b-row>
                    </span>
                </b-form>
            </b-card-body>
            <b-card-footer class="p-12">
                <b-button variant="secondary" :disabled="disable_buttons" @click="$router.go(-1)"><i
                        class="fa fa-mail-reply-all"></i>
                    Voltar</b-button>
            </b-card-footer>
        </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import miniToastr from 'mini-toastr'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import FileUpload from 'vue-upload-component'

miniToastr.init()

const formShape = {
    id: null,
    titulo: '',
    status: true,
    item: null,
    texto: [],
    files: [],
    video_url: [],
    video_upload: [],
    documentos: []
}

export default {
    components: {
        FileUpload
    },
    mixins: [validationMixin],
    validations: {
        form: {
            titulo: {
                required
            },
            status: {
                required
            }
        }
    },
    created() {
        if (!this.validaPerfil()) {
            this.$router.push('/')
        }

        if (this.$route.params.id) {
            this.loadTutorial(this.$route.params.id)
        } else {
            this.navigate('/tutoriais')
        }
    },
    data() {
        return {
            selected: [],
            files: [],
            descricao: '',
            teste: '',
            form: Object.assign({}, formShape),
            itens: [],
            totalSize: 0,
            disable_buttons: false,
            options: [
                { text: 'Ativo', value: true },
                { text: 'Inativo', value: false }
            ],
            option_itens: [
                { 'tipo': 'TE', 'nome': 'Texto' },
                { 'tipo': 'AR', 'nome': 'Arquivo' },
                { 'tipo': 'UV', 'nome': 'Upload Vídeo' },
                { 'tipo': 'SV', 'nome': 'Streaming Vídeo' }
            ],
        }
    },
    computed: {
        isValid() {
            return !this.$v.form.$anyError
        },
        permissoes() {
            return this.$store.state.permissao.permissoes
        }
    },
    watch: {
        //
    },
    methods: {
        validaPerfil() {
            let perfil = this.$store.state.perfil.perfil
            if (perfil.is_admin_conferencia) {
                return true
            }
            return false
        },
        loadTutorial(id) {
            Vue.http.get('api/tutorial/' + id).then(response => {
                var dados = response.body.data[0]

                if (dados.textos.length > 0) {
                    for (let i = 0; i < dados.textos.length; i++) {

                        this.itens[dados.textos[i].ordem] = {
                            tipo: 'TE'
                        }

                        this.form.texto[dados.textos[i].ordem] = {
                            texto: dados.textos[i].texto,
                            ordem: dados.textos[i].ordem
                        }
                    }
                }

                if (dados.arquivos.length > 0) {
                    var arquivos = []
                    for (let i = 0; i < dados.arquivos.length; i++) {
                        this.itens[dados.arquivos[i].ordem] = {
                            tipo: 'AR'
                        }                     
                    }

                    for (let i = 0; i < this.itens.length; i++) {
                        for (let e = 0; e < dados.arquivos.length; e++) {
                            if(dados.arquivos[e].ordem == i){
                               
                                arquivos.push({
                                    id: e,
                                    caminho: dados.arquivos[e].arquivo,
                                    name: 'Documento',
                                    old: true,
                                    ordem: i
                                })

                                this.form.files[i] = {
                                    files: arquivos,
                                    ordem: i
                                }
                            }
                        }
                        var arquivos = []
                    }
                }

                if (dados.url_videos.length > 0) {
                    for (let i = 0; i < dados.url_videos.length; i++) {
                        this.itens[dados.url_videos[i].ordem] = {
                            tipo: 'SV'
                        }

                        this.form.video_url[dados.url_videos[i].ordem] = {
                            video_url: dados.url_videos[i].url_video,
                            ordem: dados.url_videos[i].ordem
                        }
                    }
                }

                if (dados.upload_videos.length > 0) {
                    for (let i = 0; i < dados.upload_videos.length; i++) {

                        this.itens[dados.upload_videos[i].ordem] = {
                            tipo: 'UV'
                        }
                        this.form.video_upload[dados.upload_videos[i].ordem] = {
                            video_upload: dados.upload_videos[i].upload_video,
                            ordem: dados.upload_videos[i].ordem,
                            url_video: process.env.ROOT_API1 + dados.upload_videos[i].upload_video
                        }
                    }
                }

                this.form.titulo = dados.titulo
                this.form.id = dados.id
                this.form.status = dados.situacao == '1 ' ? true : false
            })
        },
        findFirstError(component = this) {
            if (component.state === false) {
                if (component.$refs.input) {
                    component.$refs.input.focus()
                    return true
                }
                if (component.$refs.check) {
                    component.$refs.check.focus()
                    return true
                }
            }
            let focused = false
            component.$children.some((child) => {
                focused = this.findFirstError(child)
                return focused
            })

            return focused
        },
        abrirDocumento(documento) {
            window.open(process.env.ROOT_API1 + documento, '_blank')
        }
    }
}
</script>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>

<style>
.adicionarItem {
    margin-top: 5%;
}

.botoes-secao {
    text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/pages/site/interna/tutoriais/TutorialVisualizar.vue